module.exports = __webpack_public_path__ + "img/2009 feuerwehr winteressen 025.213a9313.jpg";